module.exports = __webpack_public_path__ + "img/education.66379a63.webp";